import { LOAD_LIKES, ADD_LIKE, REMOVE_LIKE } from "./types";
import { loadFromStorage, saveToStorage } from "../../storage";

export const loadLikes = () => (dispatch) => {
  const items = loadFromStorage("likes");
  dispatch({ type: LOAD_LIKES, payload: items });
};

export const toggleLike = (movie) => (dispatch, getState) => {
  const { likes } = getState();
  const id = movie.imdbID;

  if (likes.items[id]) {
    dispatch({ type: REMOVE_LIKE, payload: id });
  } else {
    const data = {
      imdbID: movie.imdbID,
      Title: movie.Title,
      Year: movie.Year,
      Poster: movie.Poster,
      Type: movie.Type,
      likedAt: Date.now(),
    };
    dispatch({ type: ADD_LIKE, payload: data });
  }

  // Save after dispatch
  setTimeout(() => {
    const updated = getState().likes.items;
    saveToStorage("likes", updated);
  }, 0);
};
